/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.response-dialog[_ngcontent-%COMP%] {\n  padding: 0 20px 20px 20px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvc3ZhL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9yZXNwb25zZS1kaWFsb2cvcmVzcG9uc2UtZGlhbG9nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvc3ZhL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9yZXNwb25zZS1kaWFsb2cvcmVzcG9uc2UtZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/response-dialog/response-dialog.component.scss.shim.ngstyle.ts